import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';

export const StyledDialog = styled(Dialog)`
  && .MuiPaper-root {
    background-color: #1f4449;
    min-width: 70rem;
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;
    padding: 3rem 0;
    background-image: linear-gradient(
        rgba(0, 97, 110, 0.65),
        rgba(0, 97, 110, 0.95)
      ),
      url(/natal-bg3.png);
  }
`;

export const Content = styled.div`
  display: flex;
  color: #fff;
`;

export const CloseWrapper = styled.div`
  position: absolute;
  right: 1.5rem;
  top: 1.5rem;
  width: 1rem;
  z-index: 5;

  .close {
    transition: transform 0.4s;
    width: 100%;
    cursor: pointer;
  }
`;

export const TextSection = styled.div`
  padding: 2rem;
  flex: 1;
`;

export const Head = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  position: relative;
  color: #f8a53f;

  > img {
    position: absolute;
    top: -5rem;
    left: 6rem;
    width: 8rem;
  }
`;

export const SubMsg = styled.div`
  max-width: 40rem;
  font-weight: bold;
  font-size: 2.4rem;
  letter-spacing: 0.1rem;
`;

export const ExtraMsg = styled.div`
  font-size: 1.2rem;
  margin-top: 1rem;
`;

export const Logo = styled.img`
  width: 7rem;
  margin-bottom: 1.5rem;
`;

export const TreeContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
`;

export const Action = styled.div`
  margin-top: 4rem;
  display: flex;
  justify-content: center;
`;

export const Button = styled.button`
  background: linear-gradient(to right, #8740e8, #6cc680);
  padding: 1rem 3rem;
  font-size: 1rem;
  border-radius: 50px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.5s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

export const SleighAnimation = styled.div`
  width: 100%;
  margin-top: 1.5rem;
`;
